import apiClient from "./config";
import JOB_VIEW_ENDPOINTS from "./endpoints/jobViewEndpoints";

const jobViewService = {
  // Idempotent per (user, job, day). Returns 403 with errorType
  // JOB_VIEW_LIMIT_REACHED only when a NEW job would exceed the daily cap.
  record: (jobId) =>
    apiClient.post(JOB_VIEW_ENDPOINTS.RECORD, { job_id: jobId }),

  // Banner data for the job detail page: { plan_slug, used, limit,
  // remaining, limit_reached, usage_date }.
  usage: () => apiClient.get(JOB_VIEW_ENDPOINTS.USAGE),
};

export default jobViewService;
